import React from "react"
import { graphql, Link } from "gatsby"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"
import styles from "./page.module.css";

import Layout from "../components/layout"

export const query = graphql`
  query ($slug: String!) {
        contentfulPage(slug: {eq: $slug}) {
            title
            body {
                json
            }
        }
    }
`

const Page = props => {

    const options = {
    renderNode: {
      "embedded-asset-block": node => {
        const alt = node.data.target.fields.title["en-US"]
        const { url } = node.data.target.fields.file["en-US"]
        return <img alt={alt} src={url} />
      },
    },
  }
  
  return (
    <Layout
      title={props.data.contentfulPage.title}
      showBecomeContentCreator={false}
      showTransparentNav={false}
    >
        <div className={styles.container}>
          <div className={styles.title}>
            <h2>{props.data.contentfulPage.title}</h2>
          </div>
          <div className={styles.subContainer}>
        {documentToReactComponents(
          props.data.contentfulPage.body.json,
          options
        )}
        </div>
        </div>
    </Layout>
  )
}

export default Page
